type TPopupWindowFeatures = {
  height?: number;
  screenX?: number;
  screenY?: number;
  width?: number;
};

export const POPUP_WINDOW_PREFIX = 'kitt-popup';

const WINDOW_REFS = new Map<string, Window>();

export function openPopupWindow(url: string | URL, features?: TPopupWindowFeatures): void {
  WINDOW_REFS.forEach((windowRef, key) => {
    if (windowRef.closed) {
      WINDOW_REFS.delete(key);
    }
  });

  const target = `${POPUP_WINDOW_PREFIX}-${btoa(url.toString())}`;
  const existingRef = WINDOW_REFS.get(target);

  // Manually re-focus the window to avoid page state being reset
  if (existingRef != null) {
    existingRef.focus();
    return;
  }

  const serializeFeatures = (features: TPopupWindowFeatures): string =>
    Object.keys(features)
      .map((feature) => `${feature}=${features[feature as keyof TPopupWindowFeatures]}`)
      .join(',');

  const newWindow = window.open(
    url,
    target,
    features != null ? serializeFeatures(features) : undefined,
  );

  if (newWindow != null) {
    WINDOW_REFS.set(target, newWindow);
  }
}
